import { put, call, take, select } from "redux-saga/effects";
import { SET_FETCH_ME_COMPLETED } from "../../reducers/actionTypes";
// import { updateLinkedTeamLeader, setUserTrackingInfo } from '@redux/actions/user.actions';
import {
  handleDeepLinkNavigation,
  setDeepLinkParams,
} from "../../actions/deepLink.actions";

export default function* handleDeepLink(action) {
  try {
    // wait for fetchme to be completed since all routes need user logged in
    const {
      fetchMeCompleted,
      deepLink: { deepLinkParams: deepLink },
    } = yield select(({ auth: { fetchMeCompleted }, deepLink }) => ({
      fetchMeCompleted,
      deepLink,
    }));
    if (!fetchMeCompleted) {
      yield take(SET_FETCH_ME_COMPLETED);
    }
    const { params } = action;
    // const { teamLeaderId } = params;

    // if (teamLeaderId) { yield put(updateLinkedTeamLeader(teamLeaderId)); }
    // yield put(setUserTrackingInfo({...params, time: Date.now() }));
    // yield put(handleDeepLinkNavigation(params));

    if (params["~referring_link"]) {
      yield put(handleDeepLinkNavigation(params));
      yield put(setDeepLinkParams(null));
    }
  } catch (e) {
    console.log(e, "error handling deep link");
  }
}
